import { render, staticRenderFns } from "./wfSummary.vue?vue&type=template&id=36b9a5d9"
import script from "./wfSummary.vue?vue&type=script&lang=js"
export * from "./wfSummary.vue?vue&type=script&lang=js"
import style0 from "./wfSummary.vue?vue&type=style&index=0&id=36b9a5d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports